import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Kontakt from "./components/Section/Kontakt";
import Header from "./components/Section/Header";
import Leistungen from "./components/Section/Leistungen";
import UnserTeam from "./components/Section/UnserTeam";
import Navigation from "./components/Navigation";
import Impressum from "./components/Section/Impressum";
import Datenschutz from "./components/Section/Datenschutz";
import Footer from "./components/Footer";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Layout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Navigation />
      <div className="bg-white px-6 py-16 sm:py-24 lg:px-8 min-h-[60vh]">
        <div className="mx-auto lg:max-w-6xl md:max-w-3xl sm:max-w-2xl text-center text-balance object-center items-center">
          {children}
        </div>
      </div>
      <Footer />
    </>
  );
}

function HomePage() {
  return (
    <Layout>
      <Header />
      <Leistungen short={true} />
      <UnserTeam short={true} />
      <Kontakt short={true}  />
    </Layout>
  );
}

function LeistungenPage() {
  return (
    <Layout>
      <Leistungen />
    </Layout>
  );
}

function TeamPage() {
  return (
    <Layout>
      <UnserTeam />
    </Layout>
  );
}

function KontaktPage() {
  return (
    <Layout>
      <Kontakt />
    </Layout>
  );
}

function ImpressumPage() {
  return (
    <Layout>
      <Impressum />
    </Layout>
  );
}

function DatenschutzPage() {
  return (
    <Layout>
      <Datenschutz />
    </Layout>
  );
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/omw" element={<HomePage />} />
        <Route path="/leistungen" element={<LeistungenPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/kontakt" element={<KontaktPage />} />
        <Route path="/impressum" element={<ImpressumPage />} />
        <Route path="/datenschutz" element={<DatenschutzPage />} />
      </Routes>
    </>
  );
}

export default App;
